<template>
	<importer-frame :title="data.name" @all="selectAll" @none="selectNone" @left="enableLeft" @right="enableRight">
		<div name="itemOptions" size="sm"
				v-for="(ivalue, key) in data.showBody" :key="key">
			<div class="d-flex flex-wrap justify-content-between" v-if="ivalue && ivalue.length > 0">				                 	
				<div class="item-title d-flex justify-content-between">
					<div class="h1-buttons col-12 mb-0">
						<h4>{{ key }}</h4>
						<div class="my-2">
							<button class="btn btn-secondary" @click="selectNone(key)">Keep LOCAL</button>
							<button class="btn btn-secondary" @click="selectAll(key)">Apply REMOTE</button>
							<button class="btn btn-secondary" v-if="data.name == 'hyper-dispatch'" @click="enableLeft(key)">Merge into LOCAL</button>
							<button class="btn btn-secondary" v-if="data.name == 'hyper-dispatch'" @click="enableRight(key)">Merge into REMOTE</button>
							
						</div>
					</div>
				</div>
				<div class="d-flex item-body" v-for="element in ivalue" :key="element.id"> 
					<div class="w-25 m-1">
						<select size="sm"  class="w-100" :class="optionsClass[element.selectedOption]" v-model="element.selectedOption" @change="changeOption(element)">
							<option :class="option.class" v-for="option in options[itemOptions(element)]" :key="option.name">{{option.name}}</option>
						</select>
					</div>
					<div class="d-flex justify-content-between item-body">
						<div class="w-75 m-1">
							{{ element.name }}
							<div v-if="element.duplicate" class="icon-error"></div>
						</div>
						<div v-if="element.hasDiff">
							<button class="btn btn-outline-secondary btn-sm btn-compact text-nowrap" @click="showDiff(element)">
								Show diff
							</button>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		<show-diff-dialog ref="showDiffDialog"/>
		<diff-tables-dialog ref="diffTablesDialog"/>
	</importer-frame>

</template>

<script>
import ImporterFrame from "./ImporterFrame";
import ShowDiffDialog from "./ShowDiffDialog";
import DiffTablesDialog from "./DiffTablesDialog";

export default {
	name: "GitConfigImporter",
	components: { ImporterFrame, ShowDiffDialog, DiffTablesDialog },
	props: {
		data: Object		
	},
	data() {
		return {
			selected: {},
			commitSha: null,
			gitBody: null,
			showBody: null,
			sendBody: null,
			localBody: null,
			localAndGitServerDiff: null,
			isProgress: false,
			options:{
				noDiff: [{
					name:"Local",
					class: "text-success",
					selected: true
				}],
				overwrite: [{
					name:"Remote",
					class: "text-warning",
					selected: true
				},
				{
					name:"Local",
					class: "text-success",
					selected: false
				},
				{
					name:"Merge in local",
					class: "text-success",
					selected: true
				},
				{
					name:"Merge in remote",
					class: "text-warning",
					selected: true
				}],
				delete: [{
					name:"Delete",
					class: "text-danger",
					selected: true
				},
				{
					name:"Local",
					class: "text-success",
					selected: false
				}],
				new: [{
					name:"New",
					class: "text-success",
					selected: true
				},
				{
					name:"Skip",
					class: "text-success",
					selected: false
				}],
				newData: [{
					name:"New with data",
					class: "text-success",
					selected: true
				},
				{
					name:"Skip",
					class: "text-success",
					selected: false
				},
				{
					name:"New without data",
					class: "text-success",
					selected: true
				}],
				overwriteData: [{
					name:"Remote with data",
					class: "text-warning",
					selected: true
				},
				{
					name:"Local",
					class: "text-success",
					selected: false
				},
				{
					name:"Merge in local",
					class: "text-success",
					selected: true
				},
				{
					name:"Merge in remote",
					class: "text-warning",
					selected: true
				},
				{
					name:"Remote without data",
					class: "text-warning",
					selected: true
				}],
				duplicate: [{
					name:"Remote",
					class: "text-warning",
					selected: true
				},
				{
					name:"Skip",
					class: "text-success",
					selected: false
				}]
			},
			optionsClass:{
					"Skip": "text-success",
					"New": "text-success",
					"Local": "text-success",
					"Remote": "text-warning",
					"DUPLICATE": "text-warning",
					"Keep Both": "text-success",
					"Delete": "text-danger",
					"Merge in local": "text-success",
					"Merge in remote": "text-warning",
					"New with data": "text-success",
					"Remote with data": "text-danger",
					"Remote without data": "text-warning"
			}
		};
	},
	methods: {
		parseGitBody() {
			this.localBody = JSON.parse(this.data.localBody);
			this.gitBody = JSON.parse(this.data.gitBody);

			if (this.localBody && this.localBody.localAndGitDiff) {
				this.localAndGitServerDiff = JSON.parse(JSON.stringify(this.localBody.localAndGitDiff));
				delete this.localBody.localAndGitDiff;
			}

			this.commitSha = this.data.commitSha;
			var collectionName;
			var element;
			
			for (collectionName in this.localBody) {
				for(element in this.localBody[collectionName]){
					this.localBody[collectionName][element].collectionName = collectionName;
					this.fixItemName(this.localBody[collectionName][element]);
				}
			}
			for (collectionName in this.gitBody) {
				for(element in this.gitBody[collectionName]){
					var item = this.gitBody[collectionName][element];
					item.collectionName = collectionName;
					this.fixItemName(item);
					var matchedByNameLocal = [];
					if(this.localBody && this.localBody[collectionName]){
						matchedByNameLocal = this.localBody[collectionName].filter(
							localElement => localElement.name == item.name
						);
					}
					if (matchedByNameLocal.length == 0) {
						item.isNew = true;
					}
					item.selectedOption = this.options[this.itemOptions(item)][0].name;
					
				}
			}

			for (collectionName in this.localBody) {
				var matchedByName;
				for(element in this.localBody[collectionName]){
					var localItem = this.localBody[collectionName][element];
					matchedByName = this.gitBody[collectionName].filter(
						gitElement => gitElement.name == localItem.name
					);

					if (matchedByName.length == 0) {
						localItem.onlyLocal = true;
						localItem.markedForDeletion = true;
						localItem.selectedOption = this.options[this.itemOptions(localItem)][0].name;
						this.gitBody[collectionName].push(localItem);
					}
				}
				for(element in this.localBody[collectionName]){

					matchedByName = this.gitBody[collectionName].filter(
						gitElement => gitElement.name == this.localBody[collectionName][element].name
					);
					
					if(matchedByName.length == 1){
						this.localBody[collectionName][element].selectedOption = matchedByName[0].selectedOption;
						var hasDiff = this.hasDiff(matchedByName[0], this.localBody[collectionName][element], collectionName);
						this.localBody[collectionName][element].hasDiff = hasDiff;
						matchedByName[0].hasDiff = hasDiff;
					} else {
						this.localBody[collectionName][element].duplicate = true;
						matchedByName.forEach( e => { e.duplicate = true;
							e.selectedOption = this.options[this.itemOptions(e)][0].name
						});
					}					
				}
				for(element in this.gitBody[collectionName]){
					matchedByName = this.gitBody[collectionName].filter(
						gitElement => gitElement.name == this.gitBody[collectionName][element].name
					);
					if (matchedByName.length > 1) {
						this.gitBody[collectionName][element].duplicate = true;
						matchedByName.forEach( e => { e.duplicate = true;
							e.selectedOption = this.options[this.itemOptions(e)][0].name
						});
					}
				}
			}
			this.data.sendBody = JSON.parse(JSON.stringify(this.gitBody));
			this.data.showBody =  JSON.parse(JSON.stringify(this.gitBody));
		},
		itemOptions(value){
			if (this.isDuplicate(value)) {
				return "duplicate";
			}
			if (this.isNew(value) && !value.onlyLocal) {
				if (value.entries) {
					return "newData";
				} else {
					return "new";
				}
				
			}
			if (!this.isNew(value) && !value.onlyLocal) {
				if(value.hasDiff){
					if (value.entries) {
						return "overwriteData";
					}  else {
						return "overwrite";
					}
				} else {
					return "noDiff";
				}
			}
			if(value.onlyLocal == true){
				return "delete";
			}
		},
		stickOptionForCollectionName(optionIndex, optionType, collectionName) {
			var element;
			for(element in this.data.showBody[collectionName]) {
				var item = this.data.showBody[collectionName][element];
				if (!optionType || this.itemOptions(item) == optionType) {
					if (this.options[this.itemOptions(item)][optionIndex]) {
						item.selectedOption = this.options[this.itemOptions(item)][optionIndex].name;
					}
				}
				if (optionType) {
					this.changeOption(item);
				}
			}
		},
		stickItemOption(optionIndex, optionType, collectionNameInput) {
			this.selected = [];
			var collectionName;
			if (optionIndex == 0) {
				this.data.sendBody = JSON.parse(JSON.stringify(this.gitBody));
			}
			if (optionIndex == 1) {
				this.data.sendBody = JSON.parse(JSON.stringify(this.localBody));
			}
			if (!collectionNameInput) {
				for (collectionName in this.data.showBody) {
					this.stickOptionForCollectionName(optionIndex, optionType, collectionName);
				}
			} else {
				this.stickOptionForCollectionName(optionIndex, optionType, collectionNameInput);
			}            
		},
		fixItemName(item){
			if (!item.name) {
				if(item.key){
					item.name=item.key;
				}
			}
			if(item.fullPath){
				item.uiFolderName = item.name;
				item.name = item.fullPath;
			}
		},
		selectAll(collectionName) {
			this.stickItemOption(0, null, collectionName)
		},
		selectNone(collectionName) {
			this.stickItemOption(1, null, collectionName)
		},
		enableLeft(collectionName) {
			this.stickItemOption(2, "overwrite", collectionName);
		},
		enableRight(collectionName) {
			this.stickItemOption(3, "overwrite", collectionName);
		},
		isSelected(item) {
			return this.selected.indexOf(item) !== -1;
		},
		isMarkedForDeletion(item) {
			return item.markedForDeletion;
		},
		isNew(item) {
			return item.isNew;
		},
		isChanged(item) {
			return item.hasDiff;
		},
		isDuplicate(value) {
			return value.duplicate;
		},
		changeOption(value) {
			this.options[this.itemOptions(value)].forEach( e => {
				if(e.name == value.selectedOption){
					value.selected = e.selected;
				}
			});
			this.selectOne(value);
		},
		showDiff: function (item) {
			if(this.hasRemoteDiff(item.collectionName, item.name)){
				this.showRemoteDiff(item)
			} else {
				this.showLocalDiff(item);
			}
		},
		showLocalDiff: function (item) {
			var matchedByName =  JSON.parse(JSON.stringify(this.filterByName(this.gitBody, item)));
			var matchedByNameLocal = JSON.parse(JSON.stringify(this.filterByName(this.localBody, item)));
			delete matchedByName[0].hasDiff;
			delete matchedByNameLocal[0].hasDiff;
			this.$refs.showDiffDialog.show(JSON.stringify(matchedByNameLocal[0], null, 2),
				JSON.stringify(matchedByName[0], null, 2), item.name);
		},
		hasRemoteDiff(collectionName, elementName){
			return this.localAndGitServerDiff &&
				this.localAndGitServerDiff[collectionName] && 
				this.localAndGitServerDiff[collectionName][elementName] !== undefined;
		},
		hasDiff(local, git, collectionName) {
			if(this.hasRemoteDiff(collectionName, local.name)) {
				return this.localAndGitServerDiff[collectionName][local.name];
			}
			var localCopy =  JSON.parse(JSON.stringify(local));
			var gitCopy = JSON.parse(JSON.stringify(git));
			delete localCopy.id;
			delete gitCopy.id;
			this.removeItemIgnoredProperties(gitCopy, gitCopy.collectionName);
			this.removeItemIgnoredProperties(localCopy, localCopy.collectionName);
			return JSON.stringify(localCopy, null, 2) !== JSON.stringify(gitCopy, null, 2);
		},
		showRemoteDiff(item) {
			// TODO when we have DSL for pipelines ( we will use exactly this code )
            this.showLocalDiff(item);
            // var matchedByName = JSON.parse(JSON.stringify(this.filterByName(JSON.parse(this.data.gitBody), item)));
			// var matchedByNameLocal = JSON.parse(JSON.stringify(this.filterByName(JSON.parse(this.data.localBody), item)));
			// GitConfig.instance().loadDiff(item.collectionName, this.data.name, {local: JSON.stringify(matchedByNameLocal[0]),
			// 	git: JSON.stringify(matchedByName[0])})
			// 	.then((res) => {
			// 		this.$refs.diffTablesDialog.show(res.data, res.data.title);
			// 	})
			// 	.catch((err) => {
			// 		this.showLocalDiff(item);
			// 	});
		},
		selectOne(item) {
			// this gets triggered before the value change so the logic is reversed
			var index;
			var matchedByName = JSON.parse(JSON.stringify(this.filterByName(this.gitBody, item)));
			var matchedByNameLocal = JSON.parse(JSON.stringify(this.filterByName(this.localBody, item)));
			var matchedByNameSend = this.filterByName(this.data.sendBody, item);
			var matchedByOriginalName = this.filterByName(this.data.sendBody, item, true);

			if(matchedByOriginalName.length > 0  && matchedByOriginalName[0].configDisabled){
				index = this.data.sendBody[item.collectionName].indexOf(matchedByOriginalName[0]);
				this.data.sendBody[item.collectionName].splice(index, 1);
			}

			if (item.selectedOption == "Merge in local" || item.selectedOption == "Merge in remote") {
				if (item.selectedOption == "Merge in local") {
					matchedByName[0].originalName = matchedByName[0].name;
					matchedByName[0].name = matchedByName[0].name + " [TO MERGE " + this.commitSha + "]";
					matchedByName[0].configDisabled = true;
				} else {
					matchedByNameLocal[0].originalName = matchedByNameLocal[0].name;
					matchedByNameLocal[0].name = matchedByNameLocal[0].name + " [MERGE IN " + this.commitSha + "]";
					matchedByNameLocal[0].configDisabled = true;
				}
			}

			if(!item.selected) {
				// only local don't delete
				if (matchedByNameSend[0].onlyLocal == true) {
					matchedByNameSend[0].markedForDeletion = false;
				} else {					
					index = this.data.sendBody[item.collectionName].indexOf(matchedByNameSend[0]);
					if (matchedByNameLocal.length > 0  && matchedByName.length > 0) {
						this.data.sendBody[item.collectionName][index] = matchedByNameLocal[0];
					} else {
						this.data.sendBody[item.collectionName].splice(index, 1);
					}
				}
			} else {			
				index = this.data.sendBody[item.collectionName].indexOf(matchedByNameSend[0]);
				if (matchedByNameSend.onlyLocal == true) {
					matchedByNameSend.markedForDeletion = true;
				} else {
					this.data.sendBody[item.collectionName][index] = matchedByName[0];
					if (item.selectedOption == "Merge in local" || item.selectedOption == "Merge in remote") {
						this.data.sendBody[item.collectionName].splice(index+1, 0, matchedByNameLocal[0]);
					}
				}
			}
			if (item.selectedOption.includes("without data")) {
				matchedByNameSend[0].entries = null;
			}
		},
		filterByName(list, item, matchByOriginalName) {
			return list[item.collectionName].filter(
				localElement => localElement && ( (!matchByOriginalName && localElement.name == item.name) ||
					matchByOriginalName && localElement.originalName == item.name && localElement.configDisabled == true )
			);
		},
		removeItemIgnoredProperties(item, collectionName) {

			var ignoreProperties = {
				"hyper-dispatch" : {
					"pipelines": [ ["nodes", "folder", "stage"], ["createdAt"],["updatedAt"], ["nodes", "data", "stage"] ],
					"queues": [["id"], ["folder"], ["acl"]]
				},
				"hyper-file" : {
					"dispatchers": [["id"], ["acl"]],
					"folders": [["id"], ["acl"]]
				},
				"hyper-store" : {
					"queries": [["id"], ["folder"], ["acl"], ["databaseConfigId"]],
					"schemas": [["id"], ["folder"], ["acl"], ["databaseConfigId"]],
					"dispatchers": [["id"], ["folder"], ["acl"], ["schemaId"]]
				},
				"hyper-crawl" : {
					"crawlingCategories": [["id"], ["acl"]],
					"crawlingTargets": [["id"], ["acl"]],
					"scrapingProfiles": [["id"], ["acl"]]
				},
				"hyper-social" : {
					"historyConfigs": [["id"], ["acl"]],
					"historyFilters": [["id"], ["acl"]],
					"liveConfigs": [["id"], ["acl"]],
					"liveFilters": [["id"], ["acl"]]
				},
				"hyper-mail" : {
					"templates": [["id"], ["acl"]],
					"accounts": [["id"], ["acl"]]
				},
				"tex" : {
					"annotations": [["id"], ["acl"]],
					"dispatchers": [["id"], ["acl"]],
					"profiles": [["id"], ["acl"]],
					"rulesets": [["id"], ["acl"]],
					"references": [["id"], ["acl"]],
					"rules": [["id"], ["acl"]],
					"testCases": [["id"], ["acl"]]
				}

			};

			if(ignoreProperties[this.data.name] && ignoreProperties[this.data.name][collectionName]){
				ignoreProperties[this.data.name][collectionName].forEach(properties => {
					this.recursivePropClean(item, properties, 0);
				});
			}
		},
		recursivePropClean(data, properties, sanityCounter) {
			if (sanityCounter > 1000000) {
				return;
			}
			sanityCounter++;
			if (properties.length == 1) {
				data[properties[0]] = null;
				delete data[properties[0]];
				return;
			}
			var spliced = properties.slice(1, (properties.length - 1));
			
			if (Array.isArray(data[properties[0]])) {
				data[properties[0]].forEach(e => {
					this.recursivePropClean(e, spliced, sanityCounter);
				});
			} else if (data[properties[0]] !== null && typeof data[properties[0]] === "object") {
				if (data[properties[0]][properties[1]]) {
					this.recursivePropClean(data[properties[0]], spliced, sanityCounter);
				} else {
					for (var value of Object.values(data[properties[0]])) {
						this.recursivePropClean(value, spliced, sanityCounter);
					}
				}
			}
		}
		
	},
	beforeMount(){
		this.parseGitBody();
		if (!this.data.showBodyString){
			this.selectAll();
		}
	},
	mounted() {
		if (this.data.showBodyString) {
			this.data.showBody = JSON.parse(this.data.showBodyString);
		}
	}
};
</script>
	
<style scoped>
	.bv-no-focus-ring {
		width: 100%;
	}
	.item-body {
		width: 48%;
	}
	.item-title {
		width: 100%;
		margin-top: 2rem;
	}
	.item-title h4 {
		font-size: 1rem;
		text-transform: uppercase;
		font-weight: 400;
	}
	.item-body div {
		font-size: 1rem;
	}
	.item-body span {
		font-size: 1rem;
	}
	#collapse-3 {
		width: 100%;
	}
	.btn-compact {
		line-height:1;
	}
	.icon-error {
		display: inline-block
	}
</style>